const $ = require('jquery');

window.simengie = {
    Factories: {},
    Layouts: {}
};
simengie.Engine = function (el, config) {
    if (!el || el.length === 0) return null;

    var engine = {
        sel: $(el).attr('id') || $(el).attr('class') || 'default',
        cntnr: $(el),
        config: config,
        context: null,
        factories: {}
    };

    engine.hooker = new simengie.Hooker(engine);
    engine.looper = new simengie.Looper(engine);
    engine.bag = new simengie.Bag(engine);
    engine.scroller = new simengie.Scroller(engine);
    engine.initialiser = new simengie.Initialiser(engine);

    engine.h = engine.hooker;
    engine.b = engine.bag;
    engine.l = engine.looper;

    if (config.onComplete)
        engine.onComplete = config.onComplete;
    if (config.errorPane)
        engine.errorPane = config.errorPane;

    // PUBLIC
    engine.next = function (cb) {
        if (engine.b.isStackEmpty()) {
            releaseStep(engine.b.getFirstStepId(), cb);
        } else {
            validate(function (isStepValid) {
                if (isStepValid) {
                    engine.b.harvestCurrent(function () {
                        engine.b.getCurrent().getNext(function (nextId) {
                            hideOnNext(function () {
                                releaseStep(nextId, cb);
                            });
                        });
                    });
                }
            });
        }
    };
    engine.previous = function (cb) {
        if (!engine.b.isStackEmpty() && !engine.b.isFirstStep()) {
            hideOnPrevious(function () {
                releaseStep(engine.b.getCurrent().id, cb, 'previous');
            });
        }
    };
    engine.restartLoop = function (restartStepId, cb) {
        validate(function (isStepValid) {
            if (isStepValid) {
                engine.b.harvestCurrent(function () {
                    hideOnNext(function () {
                        releaseStep(restartStepId, cb, 'restartLoop');
                    });
                });
            }
        });
    };
    engine.exitLoop = function (restartStepId, cb) {
        validate(function (isStepValid) {
            if (isStepValid) {
                engine.b.harvestCurrent(function () {
                    engine.b.getCurrent().getNext(function (nextId) {
                        hideOnNext(function () {
                            releaseStep(nextId, cb, 'exitLoop');
                        });
                    });
                });
            }
        });
    };
    engine.complete = function (cb) {
        var sendingClass = 'is-sending-data';
        if (!engine.cntnr.hasClass(sendingClass))
            validate(function (isStepValid) {
                if (isStepValid) {
                    engine.b.harvestCurrent(function () {
                        var allData = engine.b.export();
                        engine.cntnr.addClass(sendingClass);
                        engine.onComplete(allData, function (isSuccessfull) {
                            engine.cntnr.removeClass(sendingClass);
                            if (isSuccessfull) {
                                engine.b.markHasFinished();
                                engine.b.getCurrent().getNext(function (nextId) {
                                    hideOnNext(function () {
                                        releaseStep(nextId, cb);
                                    });
                                });
                            } else {
                                engine.goToError(cb);
                            }
                        }, engine);
                    });
                }
            });
    };
    engine.goToError = function (cb) {
        engine.b.markHasFinished();
        if (engine.errorPane) {
            hideOnNext(function () {
                releaseStep(engine.errorPane, cb);
            });
        } else {
            alert('Une erreur est survenue au cours de la simulation.');
        }
    };
    engine.load = function (loadingFunc) {
        var z = this;
        this.cntnr.addClass('sim-is-loading');
        loadingFunc(function (cb) {
            z.cntnr.removeClass('sim-is-loading');
        });
    };
    engine.init = function () {
        engine.initialiser.run();
    };
    engine.reloadCurrentPane = function (cb) {
        hideOnPrevious(function () {
            engine.b.loadSavedState(function () {
                renderStep(engine.b.getStep(engine.b.getCurrent().id), cb);
            });
        });
    };
    engine.constraintHeight = function () {
        engine.cntnr.css('transition', 'none');
        engine.cntnr.addClass('sim-is-constraint');
    };
    engine.releaseHeight = function () {
        engine.cntnr.css('transition', 'max-height 2s');
        setTimeout(function () {
            engine.cntnr.removeClass('sim-is-constraint');
        }, 150);
    };

    // PRIVATE
    var hideOnNext = function (cb) {
        engine.b.getCurrent().hideOnNext(function () {
            if (cb) cb();
        });
    };
    var hideOnPrevious = function (cb) {
        engine.b.getCurrent().hideOnPrevious(function () {
            if (cb) cb();
        });
    };
    var releaseStep = function (stepId, cb, mode) {
        var step;
        if (!mode) mode = 'normal';
        if (mode === 'previous') {
            var popped = engine.b.pop();
            if (popped.loop) {
                if (popped.loop.step
                    && popped.loop.step === 'start') {
                    engine.looper.getMeOutOfTheLoop();
                }
            }
            step = engine.b.getCurrent();
            if (step.loop) {
                if (step.loop
                    && step.loop.step === 'exit')
                    engine.looper.getMeBackInTheLoop(step.loop);
            }
        } else {
            step = engine.b.getStep(stepId);
            engine.b.push(step);
            if (mode === 'normal') { //  || mode === 'previous'
                engine.looper.treatStep(step);
            } else if (mode === 'restartLoop') {
                engine.looper.restartLoop();
            } else if (mode === 'exitLoop') {
                engine.looper.exitLoop();
            }
        }
        renderStep(step, cb);
    };
    var renderStep = function (step, cb) {
        step.render(
            function () {
                engine.h.doHooks(
                    'step.render.after',
                    {
                        step: step
                    },
                    function () {
                        engine.b.updateSavedState();
                        if (engine.config.autoScroll && !engine.b.isFirstStep()) {
                            engine.scroller.goTop();
                        }
                        if (cb)
                            cb();
                    }
                );
            });
    };
    var validate = function (cb) {
        engine.b.getCurrent().validate(function (isStepValid) {
            if (isStepValid) {
                if (cb) cb(true);
            }
        });
    };

    // RETURN INSTANCE
    return engine;
};
simengie.Bag = function (engine) {
    var instance = this;
    // PRIVATE VARS
    var steps = [];
    var state = {
        current: null,
        data: {},
        stack: [],
        hasSavedData: false,
        isFinished: false,
        firstStepId: null,
        idsDictionnary: {} //'mon-id' : 12
    };
    var hasToPersist = 5;
    this.hasSaved = 0;

    // CHANGE STATE FUNCS - Initialisation
    this.persistId = function (id, indice) {
        state.idsDictionnary[id] = indice;
    };
    this.setFirstStepId = function (id) {
        state.firstStepId = id;
    };
    this.addStep = function (step) {
        steps.push(step);
    };
    // CHANGE STATE FUNCS - Usage
    this.push = function (step) {
        state.stack.push(step.indice);
        state.current = step.indice;
    };
    this.pop = function () {
        var popped = steps[state.stack.pop()];
        var stepUniqueId = popped.id;
        if (popped.loop) {
            var loopKey = engine.looper.generateIterationIdentifier();
            stepUniqueId = loopKey + stepUniqueId;
        }
        for (var dataKey in state.data) {
            var dataItem = state.data[dataKey];
            if (dataItem.stepUniqueId === stepUniqueId) {
                delete state.data[dataKey];
            }
        }
        state.current = state.stack[state.stack.length - 1];
        return popped;
    };
    this.harvestCurrent = function (cb) {
        var step = this.getCurrent();
        var finished = 0;
        for (var i = 0; i < step.elements.length; i++) {
            var child = step.elements[i];
            child.collect(function (data) {
                if (data)
                    instance.addData(step, data);
                if (cb) {
                    finished++;
                    if (finished === step.elements.length)
                        cb();
                }
            });
        }
    };
    this.addData = function (step, toAdd) {
        var loop = engine.looper.get();
        var loopKey = '';
        var stepUniqueId = step.id;

        if (loop) {
            loopKey = engine.looper.generateIterationIdentifier(loop);
            stepUniqueId = loopKey + stepUniqueId;
        }

        for (var key in toAdd) {
            var value = toAdd[key];
            var computedKey = loopKey + key;

            state.data[computedKey] = {
                stepUniqueId: stepUniqueId,
                key: key,
                value: value
            };
            state.hasSavedData = true;
            if (loop) {
                state.data[computedKey]['loop'] = {
                    name: loop.name,
                    indice: loop.indice,
                    parent: loop.parent
                }
            }
        }
    };
    // CHANGE STATE FUNCS - After simulation
    this.markHasFinished = function () {
        state.isFinished = true;
    };
    // GET STATE INFOS
    this.isStackEmpty = function () {
        return state.stack.length === 0;
    };
    this.isFirstStep = function () {
        return state.stack.length === 1;
    };
    this.getCurrent = function () {
        return steps[state.current];
    };
    this.getFirstStepId = function (id) {
        return state.firstStepId;
    };
    this.isFinished = function () {
        return state.isFinished;
    };
    this.getStep = function (stepId) {
        return steps[getPaneIndice(stepId)];
    };
    this.get = function (key) {
        if (key)
            return state.data[key];
        else
            return state.data;
    };
    this.export = function (scope, mode) {
        if (!scope) scope = 'all'; // all / loop / iteration
        if (!mode) mode = 'flat'; // flat / built

        var output = computeData(scope);

        if (mode === 'built') {
            output = buildObjects(output);
        }

        return output;
    };
    // PERSISTS MANAGEMENT
    this.loadSavedState = function (cb) {
        var savedStateStr = localStorage.getItem(getSavedStateKey());
        var savedState = JSON.parse(savedStateStr);
        state = savedState.bag;
        engine.l.reloadState(savedState.looper);
        cb();
    };
    this.hasSavedState = function () {
        var savedStateStr = localStorage.getItem(getSavedStateKey());
        var savedState = JSON.parse(savedStateStr);
        return savedState && savedState.bag.hasSavedData;
    };
    this.updateSavedState = function () {
        if (state.isFinished) {
            this.cleanSavedState();
            hasSaved = 0;
        } else if (instance.hasSaved >= hasToPersist) {
            var stateStr = JSON.stringify({
                bag: state,
                looper: engine.l.exportState()
            });
            localStorage.setItem(getSavedStateKey(), stateStr);
        }
    };
    this.cleanSavedState = function () {
        localStorage.removeItem(getSavedStateKey());
    };

    // PRIVATE
    var init = function () {
        if (engine.config.persist && (engine.config.persist.hasToPersist || engine.config.persist.hasToPersist === 0)) {
            hasToPersist = engine.config.persist.hasToPersist;
        }
    };
    // SIMULATION MANAGEMENT
    var getPaneIndice = function (stepId) {
        var stepIndice = stepId;
        if (isNaN(stepId)) {
            stepIndice = state.idsDictionnary[stepId];
        }
        return stepIndice;
    };
    var computeData = function (scope) {
        var output = {};
        var keyPattern = null;
        if (scope === 'loop') {
            keyPattern = engine.looper.generateLoopIdentifier();
        } else if (scope === 'iteration') {
            keyPattern = engine.looper.generateIterationIdentifier();
        }

        for (var key in state.data) {
            var item = state.data[key];
            if (keyPattern) {
                if (key.startsWith(keyPattern)) {
                    output[key] = item.value;
                }
            } else {
                output[key] = item.value;
            }
        }
        return output;
    };
    var buildObjects = function (input) {
        var output = {};
        for (var inputKey in input) {
            var itemValue = input[inputKey];
            var keyMap = inputKey.split('.');
            var pointer = output;
            for (var i = 0; i < keyMap.length; i++) {
                var key = keyMap[i];
                if (i === keyMap.length - 1) {
                    pointer[key] = itemValue;
                } else {
                    if (!pointer[key]) {
                        pointer[key] = {};
                    }
                    pointer = pointer[key];
                }
            }

        }
        return output;
    };
    var getSavedStateKey = function () {
        return 'simulator-' + engine.sel;
    };
    init();
};
simengie.Hooker = function (engine) {
    // PRIVATE VARS
    var hooks = {};
    var sortFuncs = function (toSort) {
        toSort.sort(function (a, b) {
            if (a.priority < b.priority)
                return -1;
            if (a.priority > b.priority)
                return 1;
            return 0;
        });
        return toSort;
    };
    // PUBLIC
    this.addHook = function (name, func, priority) {
        if (!priority) priority = 0;
        if (!hooks[name]) {
            hooks[name] = [];
        }
        hooks[name].push({
            func: func,
            priority: priority
        });
    };
    this.doHooks = function (name, params, cb) {
        if (hooks[name] && hooks[name].length > 0) {
            var toRun = sortFuncs(hooks[name]);
            var counter = 0;
            for (var i = toRun.length - 1; i >= 0; i--) {
                var item = toRun[i];
                item.func(params);
            }
        }
        if (cb) cb();
    };
};
simengie.Layout = function (config) {
    this.root = config.root;
    this.header = config.header;
    this.body = config.body;
    this.footer = config.footer;
};
simengie.Looper = function (engine) {
    // PRIVATE VARS
    var instance = this;
    var stack = [];
    var loops = {};

    // PUBLIC
    this.treatStep = function (step) {
        if (step.loop) {
            var loop = normalize(step.loop);
            var existingLoop = loops[loop.name];
            if (!existingLoop) {
                startLoop(loop);
            } else if (currentLoopName() !== loop.name) {
                stack.push(loop.name);
                existingLoop.indice = 1;
            }
        }
    };
    this.restartLoop = function () {
        this.get().indice++;
    };
    this.getMeOutOfTheLoop = function () {
        var loop = this.get();
        if (loop.indice > 1)
            loop.indice--;
        else
            exitLoop();
    };
    this.getMeBackInTheLoop = function (loop) {
        loop = normalize(loop);
        stack.push(loop.name);
    };
    this.exitLoop = function () {
        exitLoop();
    };
    this.get = function () {
        if (stack.length !== 0)
            return loops[currentLoopName()];
        else
            return false;
    };
    this.find = function (name) {
        return loops[name];
    };
    this.generateLoopIdentifier = function (loop) {
        if (!loop) loop = this.get();
        else loop = normalize(loop);
        var identifier = '';
        var loopPointer = findLoopLevel(loop);
        var addIndice = false;
        do {
            var loopItem = loops[stack[loopPointer]];
            var toAppend = loopItem.name + '.';
            if (addIndice) {
                toAppend += loopItem.indice + '.';
            } else {
                addIndice = true;
            }
            identifier = toAppend + identifier;
            loopPointer--;
        } while (loopPointer >= 0);

        return identifier;
    };
    this.generateIterationIdentifier = function (loop) {
        if (!loop) loop = this.get();
        else loop = normalize(loop);
        var identifier = '';

        if (loop) {
            var loopPointer = findLoopLevel(loop);
            do {
                var loopItem = loops[stack[loopPointer]];
                identifier = loopItem.name + '.' + loopItem.indice + '.' + identifier;
                loopPointer--;
            } while (loopPointer >= 0);
        }

        return identifier;
    };

    this.exportState = function () {
        return {
            stack: stack,
            loops: loops
        };
    };
    this.reloadState = function (looperState) {
        stack = looperState.stack;
        loops = looperState.loops;
    };

    // PRIVATE
    var findLoopLevel = function (loop) {
        var level;
        for (let i = stack.length - 1; i >= 0; i--) {
            if (stack[i] === loop.name) {
                level = i;
            }
        }
        return level;
    };
    var currentLoopName = function () {
        if (stack.length > 0)
            return stack[stack.length - 1];
        else
            return '';
    };
    var startLoop = function (loop) {
        stack.push(loop.name);
        loops[loop.name] = {
            name: loop.name,
            indice: 1, // For muggles eyes only, so start from one
        };
    };
    var exitLoop = function () {
        stack.pop();
    };
    var normalize = function (stepLoop) {
        var loop = {};
        if (typeof stepLoop === 'string') {
            loop.name = stepLoop;
        } else {
            loop = stepLoop;
        }
        return loop;
    };
};
simengie.Scroller = function (engine) {
    // PRIVATE VARS
    var instance = this;
    var isScrolling = false;

    // PUBLIC
    this.goTop = function () {
        if (!isScrolling) {
            scrollTo(engine.cntnr);
        }
    };

    // PRIVATE
    var scrollTo = function (el) {
        isScrolling = true;
        var cbOk = false;
        var scrollTop = scrollPosition(el);
        if (scrollTop) {
            $('html,body').animate({
                scrollTop: scrollTop
            }, 500, 'linear', function () {
                if (!cbOk) {
                    cbOk = true;
                    isScrolling = false;
                }
            });
        } else {
            isScrolling = false;
        }
    };
    var scrollPosition = function (target) {
        var offset = $(target).offset();
        if (typeof offset != 'undefined') {
            return offset.top - getStickyHeaderSize();
        } else {
            return false;
        }
    };
    var getStickyHeaderSize = function () {
        var header = $("body > header");
        if (header.css('position') === 'fixed') {
            return header.outerHeight();
        } else {
            return 0;
        }
    };
};
simengie.Initialiser = function (engine) {
    // PUBLIC
    this.run = function () {
        initFramework(function () {
            engine.h.doHooks(
                'engine.init.framework_initialized',
                {
                    engine: engine
                },
                function () {
                    initInstanceConfig(function () {
                        engine.h.doHooks(
                            'engine.init.after',
                            {
                                engine: engine
                            },
                            function () {
                                kickIt();
                            }
                        );
                    });
                }
            );
        });
    };

    // PRIVATE
    var kickIt = function () {
        if (engine.config.stateLoader && engine.b.hasSavedState()) {
            engine.cntnr.append(
                engine.factories.stateLoader(engine.config.stateLoader)
            );
        }
        engine.next();
    };
    var initFramework = function (cb) {
        for (var helperName in simengie.Factories) {
            var helperCtor = simengie.Factories[helperName];
            engine.factories[helperName] = helperCtor(engine);
        }
        cb();
    };
    var initInstanceConfig = function (cb) {
        if (engine.context && engine.context.startWith)
            engine.b.setFirstStepId(engine.context.startWith);
        else if (engine.config.firstStepId)
            engine.b.setFirstStepId(engine.config.firstStepId);

        $.each(engine.config.steps, function (k, stepConfig) {
            initStep(k, stepConfig);
        });

        if (engine.context && engine.context.dataToSet) {
            for (var stepToAlterId in engine.context.dataToSet) {
                var step = engine.b.getStep(stepToAlterId);
                var dataToSet = engine.context.dataToSet[stepToAlterId];
                engine.l.treatStep(step);
                engine.b.addData(step, dataToSet);
            }
        }

        cb();
    };
    var initStep = function (indice, stepConfig) {
        var stateFirstStepId = engine.b.getFirstStepId();
        if (stateFirstStepId === null) {
            stepConfig.isFirstStep = true;
            engine.b.setFirstStepId(indice);
        } else if (indice === stateFirstStepId || stepConfig.id === stateFirstStepId) {
            stepConfig.isFirstStep = true;
        }

        if (stepConfig.id) {
            engine.b.persistId(stepConfig.id, indice);
        }
        var step = simengie.Step(indice, stepConfig, engine);
        step.prepareStep(function (stepRootNode) {
            engine.b.addStep(step);
            engine.cntnr.append(stepRootNode);
        });
    };
};
simengie.Element = function (step, cntnr, config, type) {
    this.type = type || 'Element';
    this.rootEl = cntnr || $();
    this.step = step;
    if (step) {
        this.engine = step.engine;
    }

    this.config = config || {};

    this.class = this.config.class || '';
    this.name = this.config.name;
    this.regex = this.config.regex;
    this.default = this.config.default || null;
    this.data = this.config.default || null;

    this.onError = this.config.onError;
    this.onChange = this.config.onChange;

    this.isHidden = this.config.isHidden || false;
    this.isOptional = this.config.optional || false;
    this.isDisable = this.config.isDisable || false;

    this.elements = [];
    this.isGenerated = false;
    this.errorCntnr = null;

    if (this.isHidden)
        this.hide();
    if (this.isDisable)
        this.disable();
};
simengie.Element.prototype.hide = function (cb) {
    this.isHidden = true;
    this.rootEl.addClass('sim-hidden-element');
    if (cb)
        cb();
};
simengie.Element.prototype.show = function (cb) {
    this.isHidden = false;
    this.rootEl.removeClass('sim-hidden-element');
    if (cb)
        cb();
};
simengie.Element.prototype.append = function (element) {
    if (this.type === 'Step') {
        element.step = this;
        if (element.name) {
            this.els[element.name] = element;
        }
    } else {
        if (element.name) {
            this.step.els[element.name] = element;
        }
    }
    this.elements.push(element);
};
simengie.Element.prototype.collect = function (cb) {
    if (this.data || this.isDisable) {
        var output = {};
        output[this.name] = this.data;
        cb(output);
    } else {
        cb();
    }
};
simengie.Element.prototype.validate = function (cb) {
    cb(true);
};
simengie.Element.prototype.setData = function (input) {
    this.data = input;
    this.engine.b.hasSaved++;
};
simengie.Element.prototype.markAsFalse = function () {
    this.cleanErrorCntnr();
    this.rootEl.addClass('error');
    var message = null;
    switch (typeof this.onError) {
        case "function":
            message = this.onError();
            break;
        case "string":
            message = this.onError;
            break;
    }
    if (message) {
        this.releaseErrorCntnr(message);
    }
};
simengie.Element.prototype.markAsValid = function () {
    this.rootEl.addClass('is-valid');
    this.cleanErrorCntnr();
};
simengie.Element.prototype.releaseErrorCntnr = function (message) {
    this.errorCntnr = $('<div>')
        .addClass('sim-error-message')
        .html(message);
    this.errorCntnr.appendTo(this.rootEl);
};
simengie.Element.prototype.cleanErrorCntnr = function () {
    if (this.errorCntnr) {
        this.errorCntnr.remove();
        this.errorCntnr = null;
    }
};
simengie.Element.prototype.render = function (cb) {
    this.isGenerated = true;
    var z = this;
    if (this.name) {
        var occurenceData = this.engine.b.get(
            this.engine.l.generateIterationIdentifier(this.step.loop) + this.name
        );
        if (occurenceData) {
            this.data = occurenceData.value;
        } else if (this.default) {
            this.data = this.default;
        } else {
            this.data = null;
        }
    }
    this.generate(function () {
        z.rootEl.addClass(z.class);
        if (z.commonGen)
            z.commonGen();
        if (cb)
            cb(z.rootEl);
    });
};
simengie.Element.prototype.load = function (param) {
    var z = this;
    if (typeof (param) === 'function') {
        this.disable();
        this.step.engine.load(function (cb) {
            param(function () {
                z.render(function () {
                    z.enable();
                    cb();
                });
            });
        });
    } else {
        for (var item in param) {
            this[item] = param[item];
        }
        this.render(function () {
            z.enable();
        });
    }
};
simengie.Element.prototype.disable = function () {
    this.isDisable = true;
    this.rootEl.addClass('sim-is-disable')
};
simengie.Element.prototype.enable = function () {
    this.isDisable = false;
    this.rootEl.removeClass('sim-is-disable');
};
simengie.Step = function (indice, config, engine) {
    var element = new simengie.Element(null, $(), config, 'Step');

    if (config.id) {
        element.id = config.id;
    } else {
        element.id = indice;
    }
    element.indice = indice;
    element.isActive = false;
    element.isValid = null;
    element.l = null;
    element.els = {};

    element.loop = config.loop;
    element.layout = config.layout || "default";
    element.isFirstStep = (config.isFirstStep ? true : false);
    element.isInvisible = (config.isInvisible ? true : false);
    element.disableBack = config.disableBack;
    element.progress = config.progress;
    element.crumbId = config.crumbId;
    element.genElements = config.gen;
    element.onShow = config.onShow;
    element.onNext = config.onNext;
    element.onValidation = config.onValidation;

    element.engine = engine;
    element.h = engine.hooker;
    element.step = element;

    // Init Step
    element.prepareStep = function (cb) {
        var z = this;
        simengie.Layouts[this.layout](this.config, this.engine, function (layout) {
            z.l = layout;
            z.rootEl = layout.root;
            z.genElements(z);
            if (cb) cb(z.rootEl);
        });
    };
    // On step release
    element.render = function (cb) {
        var z = this;
        this.renderChildren(
            function () {
                z.renderFinal(function () {
                    if (cb)
                        cb();
                });
            });
    };
    element.renderChildren = function (cb) {
        var z = this;
        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            child.render(function (html) {
                z.l.body.append(html);
                counter++;
                if (counter === z.elements.length) {
                    cb();
                }
            });
        }
    };
    element.renderFinal = function (cb) {
        this.rootEl.addClass('active');
        this.isActive = true;
        this.rootEl.removeClass('leave');
        if (this.onShow)
            this.onShow(this);
        cb();
    };
    // After Step Show
    element.validate = function (cb) {
        var z = this;
        this.isValid = true;
        this.rootEl.removeClass('error');
        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            child.validate(function (IsChildValid) {
                counter++;
                z.isValid = z.isValid && IsChildValid;
                if (counter === z.elements.length) {
                    if (z.onValidation) {
                        z.onValidation(z, function () {
                            z.afterValidation(cb);
                        });
                    } else {
                        z.afterValidation(cb);
                    }
                }
            });
        }
    };
    element.afterValidation = function (cb) {
        if (!this.isValid)
            this.rootEl.addClass('error');
        if (cb)
            cb(this.isValid);
    };
    element.hideOnNext = function (cb) {
        this.isActive = false;
        this.rootEl.addClass('leave');
        this.rootEl.removeClass('active');
        if (this.onNext)
            this.onNext(this);
        if (cb)
            cb();
    };
    element.hideOnPrevious = function (cb) {
        this.isActive = false;
        this.rootEl.removeClass('active');
        if (cb)
            cb();
    };
    // Helpers
    element.getNext = function (cb) {
        var nextId;
        if (!this.config.next) {
            nextId = this.indice + 1;
        } else {
            switch (typeof this.config.next) {
                case 'string' :
                    nextId = this.config.next;
                    break;
                case 'number' :
                    nextId = this.config.next;
                    break;
                case 'function' :
                    nextId = this.config.next(this);
                    break;
            }
        }
        cb(nextId);
    };

    return element;
};
simengie.Layouts.default = function (config, engine, cb) {
    var header = $('<div>').addClass('sim-header');
    if (config['title']) {
        var title = $("<div>")
            .html(config['title'])
            .addClass('sim-title');
        header.append(title);
    }
    if (config['sub']) {
        var sub = $("<div>")
            .html(config['sub'])
            .addClass('sim-subline');
        header.append(sub);
    }

    var body = $('<div>').addClass('sim-body');

    var footer = $('<div>').addClass('sim-footer');
    if (config['btn']) {
        var btn = engine.factories.btn(config['btn']);
        footer.append(btn);
    }

    var pane = $('<div>')
        .addClass('sim-pane')
        .append(header)
        .append(body)
        .append(footer);

    if (config.class)
        pane.addClass(config.class);


    var layout = new simengie.Layout({
        root: pane,
        header: header,
        body: body,
        footer: footer
    });

    cb(layout);
};
simengie.Layouts.empty = function (config, engine, cb) {
    var header = $('<div>').addClass('sim-header');
    var body = $('<div>').addClass('sim-body');
    var footer = $('<div>').addClass('sim-footer');
    var pane = $('<div>')
        .addClass('sim-pane')
        .append(header)
        .append(body)
        .append(footer);
    if (config.class)
        pane.addClass(config.class);
    var layout = new simengie.Layout({
        root: pane,
        header: header,
        body: body,
        footer: footer
    });
    cb(layout);
};
simengie.Factories.btn = function (engine) {
    return function (data) {
        var btn = $('<div>')
            .addClass('sim-btn');

        var btnText = $('<span>');

        var action = 'next';
        var text = data;
        var icon = false;

        if (typeof data !== 'string') {
            text = data.text;
            if (data.action)
                action = data.action;
            if (data.icon)
                icon = $('<i>').addClass(data.icon);
        }

        var btnCb = function () {
            if (data.cb)
                data.cb();
        };

        btnText.append(text);
        btn.append(btnText);
        if (icon)
            btn.append(icon);

        btn.click(function () {
            switch (action) {
                case 'next':
                    engine.next(btnCb);
                    break;
                case 'previous':
                    engine.previous(btnCb);
                    break;
                case 'complete' :
                    engine.complete(btnCb);
                    break;
                case 'restartLoop':
                    engine.restartLoop(
                        data.stepId,
                        btnCb
                    );
                    break;
                case 'exitLoop':
                    engine.exitLoop(
                        btnCb
                    );
                    break;
                default:
                    btnCb();
            }
        });
        return btn;
    }
};
simengie.Factories.backer = function (engine) {
    if (engine.config.disableBack)
        return false;

    var backBtn = $('<div>')
        .addClass('sim-back')
        .click(function () {
            engine.previous();
        });

    if (engine.config.backer && engine.config.backer.content) {
        backBtn.html(engine.config.backer.content);
    }

    var isBackEnable = function (step) {
        var isEnable = true;
        if (engine.b.isFinished()) {
            isEnable = false;
        }
        if (step.engine.bag.isFirstStep()) {
            isEnable = false;
        }
        if (step.disableBack) {
            isEnable = false;
        }
        return isEnable;
    };

    engine.h.addHook('step.render.after', function (params) {
        var isEnable = isBackEnable(params.step);
        if (isEnable) {
            // TODO: find a way to manage position from simulator config
            var stepFooter = params.step.rootEl.find('.sim-footer')
            stepFooter.prepend(backBtn);
        }
    });

    return {
        el: backBtn
    };
};
simengie.Factories.progressMarker = function (engine) {
    if (engine.config.disableProgressBar)
        return false;

    var cntnr = $('<div>')
        .addClass('sim-progress-cntnr');
    var bar = $('<div>')
        .addClass('sim-progress-bar')
        .appendTo(cntnr);

    var isBarEnable = function (step) {
        var isEnable = true;
        if (step.disableProgressBar) {
            isEnable = false;
        }
        if (!step.progress) {
            isEnable = false;
        }
        return isEnable;
    };

    engine.h.addHook('engine.init.after', function (params) {
        cntnr.appendTo(engine.cntnr);
    });
    engine.h.addHook('step.render.after', function (params) {
        var isEnable = isBarEnable(params.step);
        if (isEnable) {
            cntnr.addClass('sim-progress-bar-active');
            var percentage = params.step.progress + '%';
            bar.css('width', percentage);
        } else {
            cntnr.removeClass('sim-progress-bar-active');
        }
    });


    return {};
};
simengie.Factories.stateLoader = function (engine) {
    return function (data) {
        var popupCntnr = $('<div>')
            .addClass('sim-recovery-popup-cntnr')
            .append('<div class="sim-recovery-mask"></div>');
        var popup = $('<div>')
            .addClass('sim-recovery-popup')
            .appendTo(popupCntnr);

        var popupHeader = $('<div>')
            .addClass('recovery-title')
            .append('<span>' + data.title + '</span>')
            .appendTo(popup);

        var closePopup = $('<i>')
            .addClass('recovery-close-popup icon-plus')
            .appendTo(popupHeader);

        var content = $('<div>')
            .addClass('recovery-content')
            .append('<span>' + data.content + '</span>')
            .appendTo(popup);

        var actions = $('<div>')
            .addClass('actions')
            .appendTo(content);
        var reloadBtn = $('<div>')
            .append(data.recoverLabel)
            .addClass('btn-recover-simulator')
            .appendTo(actions);
        var restartBtn = $('<div>')
            .append(data.resetLabel)
            .addClass('btn-reset-simulator')
            .appendTo(actions);
        engine.constraintHeight();
        reloadBtn.click(function () {
            engine.reloadCurrentPane(function () {
                cleanLoader();
            });
        });
        restartBtn.click(function () {
            cleanLoader();
            engine.b.cleanSavedState();
        });
        closePopup.click(function () {
            cleanLoader();
            engine.b.cleanSavedState();
        });

        var cleanLoader = function () {
            popupCntnr.remove();
            engine.releaseHeight();
        };

        return popupCntnr;
    };
};
simengie.Factories.contexter = function (engine) {
    var ctxConfig = engine.config.context;
    if (!ctxConfig) return;

    var run = function () {
        let output = null;
        if (ctxConfig.func) {
            output = ctxConfig.func();
        }
        if (output === null && ctxConfig.urlPaths) {
            output = runUrlPathContextualization();
        }
        if (output === null && ctxConfig.urlParams) {
            output = runUrlParamsContextualization();
        }
        if (output) {
            engine.context = output;
        }
    };

    var runUrlPathContextualization = function () {
        var currentUrlPath = window.location.pathname;
        if (ctxConfig.urlPaths && ctxConfig.urlPaths[currentUrlPath]) {
            return ctxConfig.urlPaths[currentUrlPath];
        }
        return null;
    };
    var runUrlParamsContextualization = function () {
        var currentUrlParams = {};
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                var tmp = item.split("=");
                currentUrlParams[tmp[0]] = decodeURIComponent(tmp[1]);
            });

        for (var urlParamKey in currentUrlParams) {
            if (ctxConfig.urlParams[urlParamKey]) {
                var currentParamValue = currentUrlParams[urlParamKey];
                for (var urlParamValue in ctxConfig.urlParams[urlParamKey]) {
                    if (currentParamValue === urlParamValue) {
                        return ctxConfig.urlParams[urlParamKey][urlParamValue];
                    }
                }
            }
        }
        return null;
    };

    engine.h.addHook('engine.init.framework_initialized', function () {
        run();
    });

    return {};
};
simengie.Factories.breadCrumber = function (engine) {
    if (!engine.config.breadcrumber || !engine.config.breadcrumber.stages)
        return false;

    var cntnr = $('<div>')
        .addClass('sim-breadcrumb-cntnr');


    var crumbs = {};

    $.each(engine.config.breadcrumber.stages, function (id, conf) {
        var crumb = $('<div>')
            .addClass('sim-breadcrumb-item')
            .addClass('sim-breadcrumb-' + id)
            .appendTo(cntnr);

        $('<span>')
            .addClass('name')
            .text(conf.name)
            .appendTo(crumb);

        crumbs[id] = {
            id: id,
            el: crumb,
            config: conf,
            order: conf.order
        };
    });


    var isBreadcrumbEnable = function (step) {
        var isEnable = true;
        if (step.disableBreadcrumb) {
            isEnable = false;
        }
        if (!step.crumbId) {
            isEnable = false;
        }
        return isEnable;
    };

    engine.h.addHook('engine.init.after', function (params) {
        cntnr.appendTo(engine.cntnr);
    });
    engine.h.addHook('step.render.after', function (params) {
        var isEnable = isBreadcrumbEnable(params.step);

        var currentActive = cntnr.find('.sim-breadcrumb-item-active');
        if (currentActive && currentActive.length > 0) {
            currentActive.removeClass('sim-breadcrumb-item-active');
        }

        var currentPassed = cntnr.find('.sim-breadcrumb-item-passed');
        if (currentPassed && currentPassed.length > 0) {
            currentPassed.removeClass('sim-breadcrumb-item-passed');
        }

        if (isEnable) {
            cntnr.addClass('sim-breadcrumb-active');
            var currentCrumbItem = crumbs[params.step.crumbId];
            currentCrumbItem.el.addClass('sim-breadcrumb-item-active')

            for (var crumbId in crumbs) {
                if (crumbId !== params.step.crumbId) {
                    var crumbItem = crumbs[crumbId];
                    if (crumbItem.order < currentCrumbItem.order) {
                        crumbItem.el.addClass('sim-breadcrumb-item-passed')
                    }
                }
            }


        } else {
            cntnr.removeClass('sim-breadcrumb-active');
        }
    });

    return {};
};
simengie.Factories.svgPlaceholder = function (engine) {
    return function () {
        var cntnr = $('<div>').addClass('svg-placeholder');

        var svgpath = "http://www.w3.org/2000/svg";

        var baseImg = document.createElementNS(svgpath, "svg");
        baseImg.setAttributeNS(null, "viewBox", "0 0 1400 500");
        baseImg.setAttributeNS(null, "width", "1500");
        baseImg.setAttributeNS(null, "height", "150");

        var paths = [];

        var path1 = document.createElementNS(svgpath, "path");
        path1.setAttributeNS(null, "d", "M770.59,325H629.16a4.28,4.28,0,0,1-4.28-4.28V179.29a4.29,4.29,0,0,1,4.28-4.29H770.59a4.29,4.29,0,0,1,4.28,4.29V320.72A4.28,4.28,0,0,1,770.59,325Zm-137.14-8.56H766.3V183.58H633.45Z");
        paths.push(path1);

        var path2 = document.createElementNS(svgpath, "path");
        path2.setAttributeNS(null, "d", "M629.16,325a4.29,4.29,0,0,1-3.19-7.15l42.86-47.71a4.29,4.29,0,0,1,6.12-.27l11.15,10.46L719.86,247a4.29,4.29,0,0,1,5.88-.13l47.72,43a4.27,4.27,0,0,1,1.42,3.18v27.71a4.28,4.28,0,0,1-4.29,4.28H722.88a4.27,4.27,0,0,1-2.94-1.16l-47.66-44.7-39.93,44.45A4.29,4.29,0,0,1,629.16,325Zm95.41-8.56H766.3V294.91L723,255.9l-30.66,30.3Z");
        paths.push(path2);

        var path3 = document.createElementNS(svgpath, "path");
        path3.setAttributeNS(null, "d", "M673.31,251.29a20.58,20.58,0,1,1,20.56-20.57A20.6,20.6,0,0,1,673.31,251.29Zm0-32.57a12,12,0,1,0,12,12A12,12,0,0,0,673.31,218.72Z");
        paths.push(path3);

        for (var key in paths) {
            var path = paths[key];
            path.setAttributeNS(null, "transform", "translate(-0.13 0)");
            path.setAttributeNS(null, "class", "base-img-path");
            baseImg.append(path);
        }

        cntnr.append(baseImg);

        return cntnr;
    }
};
simengie.Element.prototype.Grid = function (config, cntnr) {
    var element = new simengie.Element(
        this.step || this,
        cntnr || $('<div>').addClass('sim-grid'),
        config,
        'Grid'
    );

    element.generate = function (cb) {
        this.rootEl.empty();
        var z = this;
        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            child.render(function (html) {
                z.rootEl.append(html);
                counter++;
                if (counter === z.elements.length && cb)
                    cb(z.rootEl);
            });
        }
        if (this.elements.length === 0 && cb)
            cb();
    };
    element.validate = function (cb) {
        var z = this;
        var isRowValid = true;
        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            child.validate(function (IsChildValid) {
                counter++;
                isRowValid = isRowValid && IsChildValid;
                if (counter === z.elements.length)
                    cb(isRowValid);
            });
        }
    };
    element.collect = function (cb) {
        var z = this;
        var counter = 0;
        var datas = null;
        for (var indice in this.elements) {
            var child = this.elements[indice];
            child.collect(function (data) {
                if (data) {
                    datas = $.extend({}, datas, data);
                }
                if (cb) {
                    counter++;
                    if (counter === z.elements.length) {
                        cb(datas);
                    }

                }
            });
        }
    };

    this.append(element);
    return element;
};
simengie.Element.prototype.Row = function (config) {
    var element = this.Grid(
        config,
        $('<div>').addClass('sim-row')
    );

    element.type = 'Row';

    return element;
};
simengie.Element.prototype.Col = function (config) {
    var element = this.Grid(
        config,
        $('<div>').addClass('sim-col')
    );

    element.type = 'Col';

    return element;
};
simengie.Element.prototype.FoldableArea = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-foldable-area'),
        config,
        'FoldableArea'
    );

    element.title = config.title;
    element.hasTobeFilled = config.hasTobeFilled;

    var summary = null;
    var summaryItems = {};
    var childMonitor = function (toMonitor) {
        if (toMonitor.onChange && !toMonitor.originalOnChange) {
            toMonitor.originalOnChange = toMonitor.onChange;
        }
        toMonitor.onChange = function () {
            for (var i = 0; i < element.elements.length; i++) {
                var child = element.elements[i];
                treatChild(child);
            }
            if (toMonitor.originalOnChange) {
                toMonitor.originalOnChange();
            }
            element.validate();
        };
    };
    var treatChild = function (child) {
        child.collect((data) => {
            var name = child.name;
            var text = child.text;
            var id = generateValueId(name);
            if (data) {
                var str = parseChildData(child.type, data[name], text);
                appendValueToSumary(id, str);
            } else {
                CleanValueFromSumary(id);
            }
            if (summary.html().length) {
                element.rootEl.addClass('is-filled');
            } else {
                element.rootEl.removeClass('is-filled');
            }
        });
    };
    var parseChildData = function (type, value, text) {
        switch (type) {
            case 'Checkbox' :
                return text;
            default:
                return value;
        }
    };
    var generateValueId = function (name) {
        var regex = /[^a-z0-9áéíóúñü \.,_-]/gim;
        return name
            .toLowerCase()
            .replace(regex, "")
            .replace(' ', "-")
            .trim();
    };
    var appendValueToSumary = function (id, str) {
        var wrapper = summaryItems[id];
        if (wrapper) {
            summaryItems[id].text(str);
        } else {
            wrapper = $('<span>').text(str);
            summaryItems[id] = wrapper;
        }
        summary.append(wrapper);
    };
    var CleanValueFromSumary = function (id, str) {
        if (summaryItems[id]) {
            summaryItems[id].remove();
            delete summaryItems[id];
        }
    };
    var markAreaHasValidity = function (isAreaValid) {
        if (isAreaValid) {
            element.rootEl.removeClass('error');
        } else {
            element.rootEl.addClass('error');
        }
    };

    element.generate = function (cb) {
        this.rootEl.empty();
        var z = this;

        var selectToggler = $('<div>')
            .addClass('select-toggler')
            .click(function () {
                element.rootEl.toggleClass('is-open');
            });

        var title = $('<div>')
            .addClass('title')
            .html(element.title);

        var selectList = $('<div>')
            .addClass('select-list');

        summary = $('<div>')
            .addClass('summary');
        summaryItems = {};

        selectToggler
            .append(title)
            .append(summary);

        this.rootEl
            .append(selectToggler)
            .append(selectList);

        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            childMonitor(child);
            treatChild(child);
            child.render(function (html) {
                selectList.append(html);
                counter++;
                if (counter === z.elements.length && cb)
                    cb(z.rootEl);
            });
        }
        if (this.elements.length === 0 && cb)
            cb();
    };
    element.validate = function (cb) {
        var isAreaValid = true;
        if (element.hasTobeFilled && !element.isHidden && Object.entries(summaryItems).length === 0) {
            isAreaValid = false;
        }
        var z = this;
        var counter = 0;
        for (var i = 0; i < this.elements.length; i++) {
            var child = this.elements[i];
            child.validate(function (IsChildValid) {
                counter++;
                isAreaValid = isAreaValid && IsChildValid;
                if (counter === z.elements.length) {
                    if (cb) {
                        cb(isAreaValid);
                    }
                }
            });
        }
        markAreaHasValidity(isAreaValid);
    };
    element.collect = function (cb) {
        var z = this;
        var counter = 0;
        var datas = null;
        for (var indice in this.elements) {
            var child = this.elements[indice];
            child.collect(function (data) {
                if (data) {
                    datas = $.extend({}, datas, data);
                }
                if (cb) {
                    counter++;
                    if (counter === z.elements.length) {
                        cb(datas);
                    }

                }
            });
        }
    };

    this.append(element);
    return element;
};
simengie.Element.prototype.InputCntnr = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-input-cntnr'),
        config,
        'InputCntnr'
    );

    element.text = config.text;
    element.placeholder = config.placeholder;
    element.infosBox = config.infosBox;

    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (this.data) {
            if (this.regex && !this.regex.test(this.data)) {
                isValid = false;
            }
        } else {
            if (!this.isOptional) {
                isValid = false;
            }
        }

        if (isValid)
            this.markAsValid();
        else
            this.markAsFalse();

        cb(isValid);
    };

    element.commonGen = function () {
        if (element.infosBox) {
            var infosBox = $('<div>')
                .addClass('sim-input-infos');

            infosBox.click(function () {
                infosBox.toggleClass('active');
            });

            $('<i>')
                .addClass(element.infosBox.icon)
                .appendTo(infosBox);

            var messages = $('<div>')
                .addClass('messages')
                .appendTo(infosBox);

            for (var key in element.infosBox.messages) {
                $('<p>')
                    .addClass('messages')
                    .append(element.infosBox.messages[key])
                    .appendTo(messages);
            }

            element.rootEl.append(infosBox);
        }
    };

    this.append(element);
    return element;
};
simengie.Element.prototype.TextField = function (config) {
    var element = this.InputCntnr(config);

    element.type = 'TextField';
    element.icon = config.icon;

    element.generate = function (cb) {
        this.rootEl.empty();
        var input = $('<input>').attr('type', 'text');

        if (this.placeholder)
            input.attr('placeholder', this.placeholder);

        if (this.data) {
            input.val(this.data);
        }

        if (this.icon)
            $('<i>')
                .addClass(this.icon)
                .appendTo(this.rootEl);

        var simInput = $('<div>')
            .addClass('sim-input');

        if (this.text) {
            var fakePlaceholder = $('<span>')
                .addClass('label')
                .text(this.text)
                .appendTo(simInput);

            fakePlaceholder.click(() => {
                input.focus();
            });
        }

        simInput
            .append(input)
            .appendTo(this.rootEl);

        input.change(function () {
            if (input.val()) {
                input.addClass('filled');
            } else {
                input.removeClass('filled');
            }
            element.setData(input.val().trim());
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };

    return this;
};
simengie.Element.prototype.Textarea = function (config) {
    var element = this.InputCntnr(config);

    element.type = 'TextArea';

    element.generate = function (cb) {
        this.rootEl.empty();
        var textarea = $('<textarea>');

        if (this.data) {
            textarea.val(this.data);
        }

        var simInput = $('<div>')
            .addClass('sim-input');

        if (this.text) {
            var fakePlaceholder = $('<div>')
                .addClass('label')
                .text(this.text)
                .appendTo(simInput);

            fakePlaceholder.click(() => {
                textarea.focus();
            });
        }

        simInput
            .append(textarea)
            .appendTo(this.rootEl);

        if (this.placeholder)
            textarea.attr('placeholder', this.placeholder);

        textarea.change(function () {
            if (textarea.val()) {
                textarea.addClass('filled');
            } else {
                textarea.removeClass('filled');
            }
            element.setData(textarea.val().trim());
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };

    return this;
};
simengie.Element.prototype.NumberField = function (config) {
    var element = this.InputCntnr(config);

    element.type = 'NumberField';

    element.icon = config.icon;
    element.min = config.min;
    element.max = config.max;
    element.inputStep = config.step;
    element.suffix = config.suffix;

    element.generate = function (cb) {
        this.rootEl.empty();
        var input = $('<input>').attr('type', 'number');

        if (this.data) {
            input.val(this.data);
        }

        if (this.placeholder)
            input.attr('placeholder', this.placeholder);
        if (this.min === 0 || this.min)
            input.attr('min', this.min);
        if (this.max === 0 || this.max)
            input.attr('max', this.max);
        if (this.inputStep)
            input.attr('step', this.inputStep);

        if (this.icon)
            $('<i>')
                .addClass(this.icon)
                .appendTo(this.rootEl);
        if (this.text)
            $('<div>')
                .addClass('label')
                .html(this.text)
                .appendTo(this.rootEl);
        if (this.suffix)
            var unity = $('<div>')
                .addClass('sim-unity')
                .text(this.suffix);

        $('<div>')
            .addClass('sim-input')
            .append(input)
            .append(unity)
            .appendTo(this.rootEl);

        input.change(function () {
            element.setData(parseFloat(input.val()));
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional) {
            if (this.data !== 0 && (!this.data || isNaN(this.data))) {
                isValid = false;
            } else {
                if ((this.min === 0 || this.min) && this.data < this.min)
                    isValid = false;
                if ((this.max === 0 || this.max) && this.data > this.max)
                    isValid = false;
            }
        }

        if (isValid)
            this.markAsValid();
        else
            this.markAsFalse();

        cb(isValid);
    };

    return this;
};
simengie.Element.prototype.EmailField = function (config) {
    config.regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var element = this.InputCntnr(config);

    element.type = 'EmailField';

    element.icon = config.icon;

    element.generate = function (cb) {
        this.rootEl.empty();
        var input = $('<input>').attr('type', 'email');

        if (this.placeholder)
            input.attr('placeholder', this.placeholder);

        if (this.data) {
            input.val(this.data);
        }

        if (this.icon)
            $('<i>')
                .addClass(this.icon)
                .appendTo(this.rootEl);

        var simInput = $('<div>')
            .addClass('sim-input')

        if (this.text) {
            var fakePlaceholder = $('<span>')
                .addClass('label')
                .text(this.text)
                .appendTo(simInput);

            fakePlaceholder.click(() => {
                input.focus();
            });
        }

        simInput
            .append(input)
            .appendTo(this.rootEl);

        input.change(function () {
            if (input.val()) {
                input.addClass('filled');
            } else {
                input.removeClass('filled');
            }
            element.setData(input.val().trim());
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };

    return this;
};
simengie.Element.prototype.PhoneField = function (config) {
    config.regex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
    var element = this.InputCntnr(config);

    element.type = 'PhoneField';

    element.icon = config.icon;

    element.generate = function (cb) {
        this.rootEl.empty();
        var input = $('<input>').attr('type', 'text');

        if (this.placeholder)
            input.attr('placeholder', this.placeholder);

        if (this.data) {
            input.val(this.data);
        }

        if (this.icon)
            $('<i>')
                .addClass(this.icon)
                .appendTo(this.rootEl);

        var simInput = $('<div>')
            .addClass('sim-input')

        if (this.text) {
            var fakePlaceholder = $('<span>')
                .addClass('label')
                .text(this.text)
                .appendTo(simInput);

            fakePlaceholder.click(() => {
                input.focus();
            });
        }

        simInput
            .append(input)
            .appendTo(this.rootEl);

        input.change(function () {
            if (input.val()) {
                input.addClass('filled');
            } else {
                input.removeClass('filled');
            }
            element.setData(input.val().trim());
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };

    return this;
};
simengie.Element.prototype.Selects = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-selects-cntnr'),
        config,
        'Selects'
    );

    element.selects = [];

    element.choices = config.choices;
    element.text = config.text;
    element.mode = config.mode || 'several';
    element.autoNext = config.autoNext || false;
    element.lightbox = config.lightbox || false;

    var lightbox = {
        el: null,
        mask: null,
        img: null,
        title: null,
        cta: null
    };

    if(!element.onError){
        element.onError = function () {
            var message = null;
            var selectedChoices = this.getSelectedChoices();
            if (this.mode === 'unique') {
                if(selectedChoices.length === 0){
                    message = 'Veuillez sélectionner un des choix proposés.';
                }else if (selectedChoices.length > 1){
                    message = "Veuillez ne sélectionner qu'un seul des choix proposés.";
                }
            } else {
                if (selectedChoices.length === 0) {
                    message = 'Veuillez sélectionner au moins un des choix proposés.'
                }
            }
            return message;
        }
    }

    element.generate = function (cb) {
        element.rootEl.empty();
        element.selects = [];

        if (element.text)
            $('<span>')
                .text(element.text)
                .appendTo(element.rootEl);

        var wrapper = $('<div>')
            .addClass('sim-selects-wrapper')
            .appendTo(element.rootEl);

        $.each(this.choices, function (k, v) {
            var choice = {};

            if (typeof v === "object") {
                choice.icon = v.icon;
                choice.img = v.img;
                choice.text = v.text;
                choice.val = v.val || v.text;
            } else {
                choice.text = v;
                choice.val = v;
            }

            choice.isSelected = element.data && element.data.indexOf(choice.val) !== -1;

            choice.el = $("<div>")
                .addClass('sim-selects-choice')
                .html(choice.text);

            if (choice.isSelected) {
                choice.el.addClass('selected');
            }

            if (choice.icon) {
                choice.el.prepend("<i class='" + choice.icon + "'></i>");
            }

            if (choice.img) {
                choice.el.prepend("<img class='select-image' src='"+ choice.img +"'/>");
            }

            if (element.lightbox) {
                choice.el.click(function () {
                    updateLightboxContent(choice);
                    showLightbox();
                });
            } else {
                choice.el.click(function () {
                    toggleItem(choice);
                });
            }

            element.selects.push(choice);
            wrapper.append(choice.el);
        });
        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        if (!this.isOptional) {
            var selectedChoices = this.getSelectedChoices();
            if (this.mode === 'unique') {
                isValid = selectedChoices.length === 1;
            } else {
                isValid = selectedChoices.length > 0;
            }
        }
        if (isValid) {
            this.markAsValid();
        } else {
            this.markAsFalse();
        }
        cb(isValid);
    };
    element.getSelectedChoices = function () {
        var output = [];
        for (var indice in this.selects) {
            if (this.selects[indice].isSelected) {
                output.push(this.selects[indice]);
            }
        }
        return output;
    }

    var buildLightbox = function () {
        lightbox.el = $('<div>')
            .addClass('sim-select-lightbox');
        lightbox.mask = $('<div>')
            .addClass('sim-lightbox-mask')
            .click(function () {
                hideLightbox();
            });

        lightbox.content = $('<div>')
            .addClass('sim-select-lightbox-content')
            .appendTo(lightbox.el);
        lightbox.cta = $('<div>')
            .addClass('sim-select-lightbox-cta')
            .text(element.lightbox.btn || 'Sélectionner')
            .appendTo(lightbox.el);
        $('<div>')
            .addClass('sim-select-lightbox-closer')
            .html('<i class="icon-plus"></i>')
            .appendTo(lightbox.el)
            .click(function () {
                hideLightbox();
            });

        element.engine.cntnr.prepend(lightbox.el);
        element.engine.cntnr.prepend(lightbox.mask);
    };
    var updateLightboxContent = function (choice) {
        lightbox.content.empty();

        var lightboxData = element.lightbox.generation(choice);
        lightbox.content.append(
            lightboxData.html
        );
        if (lightboxData.func) {
            lightboxData.func()
        }

        lightbox.cta
            .unbind('click')
            .click(function () {
                toggleItem(choice);
                hideLightbox();
            });
    };
    var showLightbox = function () {
        lightbox.el.addClass('active');
        lightbox.mask.addClass('active');
    };
    var hideLightbox = function () {
        lightbox.el.removeClass('active');
        lightbox.mask.removeClass('active');
    };

    var toggleItem = function (choice) {
        if (choice.isSelected)
            unselectItem(choice);
        else
            selectItem(choice);

        computeData();
        element.validate(function (isValid) {
            if (element.onChange) {
                element.onChange();
            }
            if (isValid)
                if (element.autoNext) {
                    element.step.engine.next();
                }
        });
    };
    var selectItem = function (choice) {
        if (element.mode === 'unique') {
            unselectAll();
        }
        choice.isSelected = true;
        choice.el.addClass('selected');
    };
    var unselectItem = function (choice) {
        choice.isSelected = false;
        choice.el.removeClass('selected');
    };
    var unselectAll = function () {
        $.each(element.selects, function (k, v) {
            unselectItem(v);
        });
    };
    var computeData = function () {
        element.data = '';
        for (var indice in element.selects) {
            var choice = element.selects[indice];
            if (choice.isSelected) {
                if (!element.data) { // only the first
                    element.setData(choice.val);
                } else {
                    element.setData(element.data + " | " + choice.val);
                }
            }
        }
    };

    if (element.lightbox) {
        buildLightbox();
    }

    this.append(element);
    return this;
};
simengie.Element.prototype.Checkbox = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-checkbox-cntnr'),
        config,
        'Checkbox'
    );

    element.text = config.text;

    element.generate = function (cb) {
        this.rootEl.empty();
        var fieldWrapper = $('<div>')
            .addClass('sim-checkbox')
            .appendTo(element.rootEl);

        var input = $('<input>')
            .attr('type', 'checkbox')
            .attr('id', element.name)
            .attr('name', element.name)
            .attr('value', element.name)
            .appendTo(fieldWrapper);

        if (element.text)
            $('<label>')
                .attr('for', element.name)
                .text(element.text)
                .appendTo(fieldWrapper);

        if (element.data) {
            input.attr('checked', 'checked');
        }

        input.change(function () {
            element.setData(input.prop("checked"));
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional && !this.data) {
            isValid = false;
        }

        if (isValid)
            this.markAsValid();
        else {
            this.markAsFalse();
        }

        cb(isValid);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.Dropdown = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-input-cntnr'),
        config,
        'Dropdown'
    );

    element.text = config.text;
    element.placeholder = config.placeholder;
    element.choices = config.choices;

    element.generate = function (cb) {
        this.rootEl.empty();
        if (this.text)
            $('<span>')
                .text(this.text)
                .appendTo(this.rootEl);

        var selectEl = $('<select>')
            .appendTo(this.rootEl);

        if (element.placeholder) {
            $('<option>')
                .text(this.placeholder)
                .val(null)
                .appendTo(selectEl);
            this.rootEl.addClass('no-value-selected-not-focus');
        }

        $.each(this.choices, function (k, v) {
            var text, value;
            if (typeof v === 'object') {
                text = v.text;
                value = v.value;
            } else {
                text = v;
                value = v;
            }
            if (value && typeof value === "string") {
                value = value.trim();
            }

            var option = $('<option>')
                .val(value)
                .text(text);

            if (element.data === value) {
                option.prop('selected', true);
            } else if (v.selected) {
                option.prop('selected', true);
                element.data = value;
            }
            option.appendTo(selectEl);
        });

        if (selectEl.niceSelect) {
            selectEl.niceSelect();
            this.rootEl.find('.nice-select').click(function () {
                element.rootEl.removeClass('no-value-selected-not-focus');
            });
        }

        selectEl.change(function () {
            element.setData(selectEl.val());
            element.validate(function (isValid) {
                if (isValid)
                    if (element.onChange) {
                        element.onChange();
                    }
            });
        });


        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional && !this.data) {
            isValid = false;
        }

        if (isValid)
            this.markAsValid();
        else
            this.markAsFalse();

        cb(isValid);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.DropdownMulti = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-input-cntnr'),
        config,
        'DropdownMulti'
    );

    element.text = config.text;
    element.placeholder = config.placeholder;
    element.choices = config.choices;

    element.generate = function (cb) {
        this.rootEl.empty();
        if (this.text)
            $('<span>')
                .text(this.text)
                .appendTo(this.rootEl);

        var selectEl = $('<select>')
            .attr('multiple', 'multiple')
            .appendTo(this.rootEl);

        var dropdownToggleText = 'Sélectionner';
        if (this.placeholder) {
            dropdownToggleText = this.placeholder;
        }

        var dropdownToggle = $('<div>')
            .addClass('dropdown-toggle')
            .text(dropdownToggleText)
            .click(function () {
                element.rootEl.find('.ms-container').toggleClass('is-open');
            });

        var pluginConfig = {
            selectableHeader: dropdownToggle
        };

        $.each(this.choices, function (k, v) {
            var text, value;
            if (typeof v === 'object') {
                text = v.text;
                value = v.value;
            } else {
                text = v;
                value = v;
            }
            if (value && typeof value === "string") {
                value = value.trim();
            }

            var option = $('<option>')
                .val(value)
                .text(text);

            if (element.data && element.data.indexOf(value) !== -1) {
                option.prop('selected', true);
            } else if (v.selected) {
                option.prop('selected', true);
                element.data = value;
            }
            option.appendTo(selectEl);
        });

        if (selectEl.multiSelect) {
            selectEl.multiSelect(pluginConfig);
        }

        selectEl.change(function () {
            let val = selectEl.val().join(', ');
            element.setData(val);
            element.validate(function (isValid) {
                if (isValid)
                    if (element.onChange) {
                        element.onChange();
                    }
            });
        });

        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional && !this.data) {
            isValid = false;
        }

        if (isValid)
            this.markAsValid();
        else
            this.markAsFalse();

        cb(isValid);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.DatePicker = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-input-cntnr'),
        config,
        'DatePicker'
    );

    element.text = config.text;
    element.months = config.months || ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    element.monthsShort = config.monthsShort || ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juill', 'août', 'sept', 'oct', 'nov', 'déc'];
    element.daysMin = config.daysMin || ['d', 'l', 'ma', 'me', 'j', 'v', 's'];
    element.autoHide = config.autoHide || true;
    element.offset = config.offset || 0;
    element.format = config.format || 'dd/mm/yyyy';
    element.weekStart = config.weekStart || 1;
    element.startDate = config.startDate || new Date().setDate(new Date().getDate() + 1);
    element.endDate = config.endDate;
    element.filterDates = config.filterDates || function () {
        return true;
    };

    element.generate = function (cb) {
        this.rootEl.empty();
        if (this.text)
            $('<span>')
                .text(this.text)
                .appendTo(this.rootEl);

        // TODO : Add default and data management
        var datepicker = $('<div>')
            .addClass('sim-date-picker')
            .data('toggle', 'datepicker')
            .appendTo(this.rootEl)
            .datepicker({
                autoHide: this.autoHide,
                offset: this.offset,
                format: this.format,
                months: this.months,
                monthsShort: this.monthsShort,
                daysMin: this.daysMin,
                weekStart: this.weekStart,
                filter: this.filterDates,
                startDate: this.startDate,
                endDate: this.endDate || null
            });

        datepicker.on('pick.datepicker', function (e) {
            element.setData(datepicker.datepicker('getDate', true));
            element.validate(function (isValid) {
                if (isValid) {
                    if (element.onChange) {
                        element.onChange();
                    }
                }
            });
        });

        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional && !this.data) {
            isValid = false;
            this.markAsFalse();
        }

        if (isValid)
            this.markAsValid();

        cb(isValid);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.Text = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-text-cntnr'),
        config,
        'Text'
    );

    element.text = (config.text ? config.text : config);

    element.generate = function (cb) {
        this.rootEl.html('<span>' + this.text + '</span>');
        if (cb)
            cb(this.rootEl);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.Summary = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-summary-cntnr'),
        config,
        'Summary'
    );

    element.scope = config.scope || 'all';
    element.renderer = config.renderer;

    element.generate = function (cb) {
        this.rootEl.empty();

        var summaryData = this.engine.bag.export(this.scope, 'built');

        this.rootEl.html(
            this.renderer(summaryData)
        );

        if (cb)
            cb(this.rootEl);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.Html = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-html-cntnr'),
        config,
        'Html'
    );

    element.html = config.html;

    element.generate = function (cb) {
        this.rootEl.html(element.html);
        if (cb)
            cb(this.rootEl);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.Loader = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-loader-cntnr'),
        config,
        'Loader'
    );

    element.html = config.html;

    element.generate = function (cb) {
        this.rootEl.html(element.html);
        if (cb)
            cb(this.rootEl);
    };
    element.render = function (cb) {
        var z = this;
        this.rootEl.addClass(this.class);
        var loading = function () {
            var delay = (Math.random()) * (3000 - 1000) + 1000;
            setTimeout(function () {
                z.step.engine.next();
            }, delay);
            cb(z.rootEl);
        };
        if (this.isGenerated || !this.generate) {
            loading();
        } else {
            this.isGenerated = true;
            this.generate(loading);
        }
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.RangeSlider = function (config) {
    var element = new simengie.Element(
        this.step || this,
        $('<div>').addClass('sim-range-slider-wrapper'),
        config,
        'RangeSlider'
    );

    element.hasInput = config.hasInput;
    element.text = config.text;
    element.min = config.min || 0; // type range input default min
    element.max = config.max || 100; // type range input default max
    element.step = config.step;
    element.suffix = config.suffix;
    element.labels = config.labels;
    element.dynamicTrace = config.dynamicTrace;
    element.dynamicTraceOffColor = config.dynamicTraceOffColor;
    element.thumbwidth = config.thumbwidth || 20;

    var generateRangeSlider = function () {
        var rangeSlider = $('<input>')
            .attr('type', 'range')
            .attr('data-thumbwidth', element.thumbwidth);

        if (element.min || element.min == 0)
            rangeSlider.attr('min', element.min);

        if (element.max || element.max == 0)
            rangeSlider.attr('max', element.max);


        if (element.data || element.data == 0) {
            rangeSlider.val(element.data);
        }

        if (element.step)
            rangeSlider.attr('step', element.step);

        if (element.hasInput)
            rangeSlider.attr('link-to', element.name + '_input');

        element.rangeSlider = rangeSlider;
        return rangeSlider;
    };
    var generateInput = function () {
        var fieldWrapper = $('<div>')
            .addClass('sim-input');

        if (element.text)
            $('<span>')
                .html(element.text)
                .appendTo(fieldWrapper);

        var input = $('<input>')
            .attr('type', 'number')
            .attr('id', element.name + '_input')
            .appendTo(fieldWrapper);

        if (element.min || element.min == 0)
            input.attr('min', element.min);

        if (element.max || element.max == 0)
            input.attr('max', element.max);

        if (element.data || element.data == 0) {
            input.val(element.data);
        }

        if (element.step)
            input.attr('step', element.step);

        if (element.suffix)
            $('<div>')
                .addClass('sim-unity')
                .text(element.suffix)
                .appendTo(fieldWrapper);

        element.input = input;
        return fieldWrapper;
    };
    var generateLabels = function () {
        var labels = element.labels;
        var rangeLabels = $('<ul class="range-labels">');
        labels.forEach(function (item) {
            var li = $('<li>')
                .attr('data-position', item.position)
                .html(item.text)
                .appendTo(rangeLabels);

            var position = ((item.position - element.min) / (element.max - element.min)) * 100;

            li.css('left', position + '%');
        });
        return rangeLabels;
    };
    var onChange = function () {
        updateThumbnail();

        if (element.dynamicTrace !== '') {
            updateDynamicTrace();
        }

        element.validate(function (isValid) {
            if (isValid) {
                if (element.onChange) {
                    element.onChange();
                }
            }
        });
    };
    var updateThumbnail = function () {
        var position = ((element.data - element.min) / element.range) * 100;
        var positionOffset = Math.round(element.thumbwidth * position / 100) - (element.thumbwidth / 2);
        element.rangeSlider.after(
            element.thumbnail
        );
        element.thumbnail
            .css('left', 'calc(' + position + '% - ' + positionOffset + 'px)');

        if (element.suffix) {
            element.thumbnail.text(element.data + ' ' + element.suffix)
        } else {
            element.thumbnail.text(element.data)
        }
    };
    var updateDynamicTrace = function () {
        var value = (element.data - element.min) / (element.max - element.min);
        $(element.rangeSlider).css('background-image',
            '-webkit-gradient(' +
            'linear, ' +
            'left top, ' +
            'right top, ' +
            'color-stop(' + value + ', ' + element.dynamicTrace + '), ' +
            'color-stop(' + value + ', ' + element.dynamicTraceOffColor + ')' +
            ')'
        );
    };

    element.generate = function (cb) {
        this.rootEl.empty();

        this.range = element.max - element.min;
        if (this.hasInput) {
            $('<div>')
                .addClass('sim-input-cntnr')
                .append(generateInput())
                .appendTo(this.rootEl);
        } else if (this.text) {
            $('<span>')
                .html(this.text)
                .appendTo(this.rootEl);
        }

        this.rangeSliderCntnr = $('<div>')
            .addClass('sim-range-slider-cntnr')
            .append(generateRangeSlider())
            .appendTo(this.rootEl);

        this.thumbnail = $('<div>')
            .addClass('thumbnail');

        if (this.labels)
            this.rangeSliderCntnr.append(generateLabels());

        this.rangeSlider.on('input', function () {
            element.setData(element.rangeSlider.val());

            if (element.hasInput)
                element.input.val(element.data);

            onChange();
        });
        if (this.hasInput)
            this.input.change(function () {
                element.setData(element.input.val());

                element.rangeSlider.val(element.data);
            });

        updateDynamicTrace();
        if (cb)
            cb(this.rootEl);
    };
    element.validate = function (cb) {
        var isValid = true;
        this.rootEl.removeClass('error');
        this.rootEl.removeClass('is-valid');

        if (!this.isOptional) {
            if (this.data !== 0 && (!this.data || isNaN(this.data))) {
                isValid = false;
            } else {
                if ((this.min === 0 || this.min) && this.data < this.min)
                    isValid = false;
                if ((this.max === 0 || this.max) && this.data > this.max)
                    isValid = false;
            }
        }

        if (isValid)
            this.markAsValid();
        else
            this.markAsFalse();

        cb(isValid);
    };

    this.append(element);
    return this;
};
simengie.Element.prototype.BtnWrapper = function (config) {
        var element = new simengie.Element(
            this.step || this,
            $('<div>').addClass('sim-btn-wrapper-cntnr'),
            config,
            'BtnWrapper'
        );

        element.generate = function (cb) {
            this.rootEl.html(
                this.engine.factories.btn(this.config)
            );
            if (cb)
                cb(this.rootEl);
        };

        this.append(element);
        return this;
    };


module.exports = simengie;